import CloseIcon from "@mui/icons-material/Close";
import SkillsModal from "../../components/modal/SkillsModal";
import { useEffect, useState } from "react";
import { Box, Typography, CssBaseline, Button, Chip } from "@mui/material";
import color from "../../components/utils/Colors";
import {
  deleteDataFromTable,
  getDataFromTable,
  insertBulkDataInTable,
} from "../../services/services";
import { useSnackbar } from "../../components/utils/SnackBar";
import { useUser } from "../../services/Context/UserContext";

function MySkills() {
  const { user } = useUser();

  const [open, setOpen] = useState(false);
  const [newSkills, setNewSkills] = useState<any>([]);
  const [data, setData] = useState<any[]>([]); // ✅ local state for skills
  const [reload, setReload] = useState(false);
  const showSnackbar = useSnackbar();

  // ✅ Fetch user skills from API
  useEffect(() => {
    if (user?.id) {
      getDataFromTable("userSkills", { userId: user.id })
        .then((res) => {
          setData(res?.data?.data ?? []);
        })
        .catch((error) => {
          showSnackbar(
            error?.response?.data?.message || "Failed to load skills",
          );
        });
    }
  }, [user?.id, reload]); // re-fetch when reload toggles
  const handleOpen = () => setOpen(true);

  const handleClose = () => {
    setOpen(false);
    setNewSkills([]);
  };

  const deleteSkill = (id: number) => {
    deleteDataFromTable("userSkills", id)
      .then((result: any) => {
        showSnackbar(result?.data?.msg || "Skill removed!");
        setReload((prev) => !prev); // ✅ toggle to trigger useEffect
      })
      .catch((error) => {
        showSnackbar(
          error?.response?.data?.message ||
            error?.response?.data?.msg ||
            "Failed to delete",
        );
      });
  };

  const addBulkSkill = () => {
    if (newSkills.length === 0) return;

    const payload = newSkills.map((o: any) => ({
      skillId: o.id,
      userId: user?.id,
    }));

    insertBulkDataInTable("userSkills", payload)
      .then((result: any) => {
        showSnackbar(result?.data?.msg || "Skills saved!");
        setReload((prev) => !prev); // ✅ toggle to trigger useEffect
      })
      .catch((error) => {
        showSnackbar(
          error?.response?.data?.message ||
            error?.response?.data?.msg ||
            "Failed to save",
        );
      });
  };

  const renderSkills = () => {
    if (data.length === 0) {
      return (
        <Typography style={{ color: "gray", padding: "10px" }}>
          No skills added yet.
        </Typography>
      );
    }
    return (
      <>
        {data.map((skill: any) => (
          <Chip
            style={{
              paddingLeft: "15px",
              paddingRight: "15px",
              color: color.firstColor,
              fontWeight: "bold",
              border: "solid 1.5px",
              borderColor: color.borderColor,
              backgroundColor: "transparent",
            }}
            key={skill.id ?? skill.skillId}
            label={
              skill?.skill?.title ?? skill?.title ?? `Skill #${skill?.skillId}`
            }
            variant="outlined"
            deleteIcon={
              <CloseIcon style={{ color: color.firstColor, height: "14px" }} />
            }
            onDelete={() => deleteSkill(skill.id)}
          />
        ))}
      </>
    );
  };

  return (
    <>
      <CssBaseline />
      <Box
        sx={(theme) => ({
          marginTop: "25px",
          flex: 1,
          p: "2%",
          borderRadius: "16px",
          boxShadow: 2,
          bgcolor:
            theme.palette.mode === "light" ? "#faecfa71" : "rgba(0, 0, 0, 0.4)",
          backdropFilter: "blur(2px)",
        })}
      >
        <Box
          sx={{
            paddingLeft: "0px",
            paddingRight: "0px",
            boxSizing: "border-box",
            borderRadius: "10px",
          }}
        >
          <div
            style={{ width: "100%", display: "flex", justifyContent: "center" }}
          >
            <Box sx={{ borderRadius: 2, width: "100%", padding: 2 }}>
              <Typography
                variant="h6"
                gutterBottom
                style={{
                  padding: "10px",
                  paddingLeft: "15px",
                  display: "flex",
                  alignItems: "center",
                  paddingBottom: "20px",
                  height: "50px",
                  fontWeight: "500",
                  fontSize: "26px",
                  marginBottom: "15px",
                  color: color.firstColor,
                }}
              >
                Skills
              </Typography>

              <div style={{ minHeight: "40vh", height: "fit-content" }}>
                <Box
                  sx={{
                    display: "flex",
                    flexWrap: "wrap",
                    gap: 3,
                    padding: "10px",
                    paddingLeft: "15px",
                  }}
                >
                  {renderSkills()}
                </Box>
              </div>

              <div
                style={{
                  padding: "10px",
                  marginBottom: "20px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "flex-end",
                  height: "40px",
                  fontWeight: "bold",
                }}
              >
                <Button id="button" onClick={handleOpen}>
                  Add Skills
                </Button>

                <SkillsModal
                  open={open}
                  setNewSkills={setNewSkills}
                  newSkills={newSkills}
                  handleClose={handleClose}
                  onSkillsSaved={addBulkSkill}
                />
              </div>
            </Box>
          </div>
        </Box>
      </Box>
    </>
  );
}

export default MySkills;
